/*eslint default-case: 0*/
import produce from 'immer';
import * as actionTypes from '../actions/actionTypes';
import initialState from './initialState';

export const customerReducer = (state = initialState.customer, action) =>
    produce(state, draft => {
        switch (action.type) {
            case actionTypes.LOAD_CUSTOMERS_SUCCESS:
                draft.data = action.payload;
                return;
        }
    });
